import apiFetch from '../apiFetch'

export default function (idRaza, token) {
  return apiFetch({endPoint: `Raza/deleteRaza`, method: 'POST', body: {idRaza}, token: token})
}
